export const PDP_MODE_INTERNAL = 'internal';
export const PDP_MODE_EXTERNAL = 'external'
export const PDP_EVENT_SHOW = 'pdp_event_show';
export const PDP_EVENT_HIDE = 'pdp_event_hide';
